import React from "react";

export const Page4Tamil = () => {
  return (
    <div className="page-tamil-container">
      <p>
        கொளப்பாடு கிராம அய்யனார் ஆலயம் சந்நிதி மற்ற இடங்களைப் போல் இல்லாமல்
        மேற்கு திசை நோக்கி உள்ளது. இதன் சிறப்பு அய்யனார் ஆலயத்திலிருந்து பார்வை
        தூரத்தில் சிவனும், விஷ்ணுவும் குடிகொண்ட திருக்கோயில் உள்ளது. அய்யனார்
        தன் தந்தை, தாயை தரிசித்துக் கொண்டே பக்தர்களுக்கு தரிசனம் தருவதாக
        இவ்வமைப்பு உள்ளது. தற்சமயம் திருப்பணி சிறப்பான முறையில் செய்யப்பட்டு
        கும்பாபிஷேகமும் செய்யப்பட்டுள்ளது.
      </p>
      <h1>
        திருக்கோயிலில் அமர்ந்து பக்தர்களுக்கு அருள்பாலிக்கும் ஆதியண்ணன் தோற்றம்
        வரலாறு:
      </h1>
      <h1>அருள்மிகு ஆதியண்ணன் : </h1>
      <p>
        கிழக்கு திசை நோக்கி அமைந்துள்ள கோயிலாகும். மக்கள் ஆதியிலேயே வழிபட்டதனால்
        ஆதியண்ணன் ஆதிசக்தியின் அருளினாலே படைக்கப்பட்டதனால் ஆதியண்ணன்,
        முனீஸ்வரன், வீரன், காத்தவராயன், கருப்பண்ணசாமி என்று கிராம தெய்வங்களாக
        மக்களால் வழிபட்டு வரும் அனைத்துக்கும் மூத்தவராக இருந்ததால் ஆதியண்ணன்
        என்ற பெயர் வந்திருக்கலாம். இக்கிராம மக்கள் நீண்ட நெடுங்காலமாக ஆதியண்ணனை
        வழிபட்டு பலன்பெற்று வாழ்கிறார்கள் என்பதற்கான சான்று இந்த கிராம வாசிகளில்
        பலரின் பெயர் ஆதியப்பன் என்றும், ஆதியம்மாள் என்றும் இருப்பதேயாகும்
      </p>
      <p>
        திருக்குறளில் முதற்பாடலிலேயே “ஆதிபகவன் முதற்றே உலகு" என்ற ஈற்றடி
        வருகிறது - இதனால் ஆதி என்ற சொல்லே அருள் தரும் சொல்லாகும். மகிமை
        பொருந்திய சொல்லாகும். ஆதியில் மண் சிலையாக இருந்து சில ஆண்டுகளுக்கு முன்
        கோயில் கட்டி கும்பாபிஷேகம் செய்த போது கற்சிலையாக உருவாகியது. தற்சமயம்
        மிகுந்த பொருட்செலவில் கம்பி சிமெண்ட் உயர்ந்த கலவை இவைகளால் கட்டுக்சிலை
        கட்டப்பட்டு கருவறையில் முன்பிருந்த சிலைக்கு பின்புறம் பூஜையில்
        வைக்கப்பட்டு அருள் பாலித்து வருகிறார் ஆதியண்ணன்.
      </p>
      <p>
        திருக்கோயிலும், கோபுரமும் அமைக்கப்பட்டு புதிய கலசங்கள் பொருத்தப்பட்டு
        வண்ணம் பூசப்பட்டு மிகப் பொலிவுடன் காட்சியளிக்கிறது. அனைவரும் வாருங்கள்
        ஆதியண்ணனை வணங்குங்கள்!
      </p>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p>அருள் பெறுங்கள் !!</p>
        <p>வளமோடு வாழுங்கள் !!!</p>
      </div>
      <h1>
        கொளப்பாடு கிராமத்தில் <br />
        அமைந்துள்ள ஸ்ரீ அய்யனார், ஸ்ரீஆதியண்ணன்
      </h1>
      <p>
        ஆலயங்களுக்கு திருப்பணி செய்து கும்பாபிஷேகத்தையும் மிகச் சிறப்பாக நடத்தி
        ஸ்ரீ அய்யனார், ஸ்ரீ ஆதியண்ணன் அருளையும் கிராமவாசிகள் மற்றும் பக்தர்களின்
        பாராட்டையும் பெற்றிருக்கும் பெங்களூர் தொழிலதிபர், திருப்பணிச் செம்மல்
        எஸ். துரைராஜ் அவர்கள் திருப்பணிப் பற்றிய சுவையான செய்திகளை சொல்கிறார்.{" "}
      </p>
    </div>
  );
};
